export default "__VITE_ASSET__Dc7OVkbA__"